export default, {breakpoints} from './BaseBox';
